module.exports = __webpack_public_path__ + "img/pikpak-logo.d1aa2df8.webp";